module.exports = __webpack_public_path__ + "img/07.ec31e023.png";